<template>
  <div v-if="!loading">
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:delete="isConfirm = !isConfirm"
      v-on:new="createHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import MonthlyPTPTNSubmissionRecord from "../../../components/payroll/monthlyptptnsubmissionrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": MonthlyPTPTNSubmissionRecord,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('allptptn.editmonthlyptptnsubmissionrec'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
      dataItems: [],
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadStatutoryReport() {
      const vm = this;

      this.$store.dispatch('get', {url: "/ptptnsubmissionrecord/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          vm.pageTitleValue = res.data.rec[0].ptptnsubreccode;
          vm.formData.userid = this.$store.getters.userId;

          this.loadPtptnSubRecPayout();

          // vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    //load tax sub rec payout
    loadPtptnSubRecPayout() {
      const vm = this;

      this.$store.dispatch('get', {url: "/ptptnsubmissionrecordpy/" + this.id})
        .then((res) => {
          vm.formData.ptptnSelectedPayouts = res.data.rec;

          for (let i = 0; i < vm.formData.ptptnSelectedPayouts.length; i++) {
            Object.assign(vm.formData.ptptnSelectedPayouts[i], { action: 2 });
          }
          //console.log(" 1234", vm.formData.ptptnSelectedPayouts[0].poid)

          this.loadPtptnSubRecRef();

          //vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    //load tax sub rec ref
    loadPtptnSubRecRef() {
      const vm = this;

      this.$store.dispatch('get', {url: "/ptptnsubmissionrecordref/" + this.id})
        .then((res) => {
          vm.formData.ptptnSubDetail = res.data.rec;

          console.log("taxsub detail", vm.formData.ptptnSubDetail);

          for (let i = 0; i < vm.formData.ptptnSubDetail.length; i++) {
            if (vm.formData.ptptnSubDetail[i].rcpdate) {
              vm.formData.ptptnSubDetail[i].rcpdate = moment(
                vm.formData.ptptnSubDetail[i].rcpdate
              ).format("YYYY-MM-DD");
            }

            // vm.formData.taxSubDetail[i].no = i + 1;
          }

          for (let i = 0; i < vm.formData.ptptnSubDetail.length; i++) {
            Object.assign(vm.formData.ptptnSubDetail[i], { action: 2 });
            Object.assign(vm.formData.ptptnSubDetail[i], { no: i + 1 });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      //update record
      this.$store.dispatch('put', {url: "/ptptnsubmissionrecord/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "monthlyptptnsubmissionrecordlist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/ptptnsubmissionrecord/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "monthlyptptnsubmissionrecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "monthlyptptnsubmissionrecordlist" });
    },

    createHandler() {
      this.$router.push({ name: "monthlyptptnsubmissionrecordnew" });
    },
  },

  mounted() {
    this.loadStatutoryReport();
  },
};
</script>